<template>
  <div>
    <div class="w-full">
      <vx-card id="languagesCard" ref="languages" title="Languages" v-show="!isLanguageListHidden">        
        <vs-table stripe ref="languagesTable" class="vs-con-loading__container" single @selected="handleSelectedLanguage" pagination max-items="10" search :data="languages"> <!-- v-scroll-to="'#languageInfoCard'" -->
          <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
            <!-- ADD NEW -->
            <div id="add-language" ref="addNew" class="p-3 mr-4 rounded-lg cursor-pointer flex items-center justify-between text-lg font-medium text-base text-primary border border-solid border-primary" @click="addNewLanguage">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add New</span>
            </div>
          </div>
          <template slot="thead">
            <vs-th sort-key="name">Name</vs-th>
            <vs-th sort-key="modifiedOn">Modified On</vs-th>
            <vs-th sort-key="modifiedBy">Modified By</vs-th>
            <vs-th></vs-th>
          </template>

          <template slot-scope="{data}">
            <vs-tr :data="languages" :key="indextr" v-for="(languages, indextr) in data" >

              <vs-td :data="data[indextr].name">
                {{ languages.name }}
              </vs-td>

              <vs-td :data="data[indextr].modifiedOn">
                {{ languages.modifiedOn.replace("T", " ").split('.')[0] }}
              </vs-td>

              <vs-td :data="data[indextr].modifiedBy">
                {{ languages.modifiedBy }}
              </vs-td>

              <vs-td>
                <vs-chip v-show="languages.isReadOnly" color="success">Inherited</vs-chip>
              </vs-td>

            </vs-tr>
          </template>
        </vs-table>
      </vx-card>
    </div>
    <div>
      <vx-card id="languageInfoCard" ref="languageInfo" title="Language Info" v-show="!isInfoHidden">
        <div class="vx-row pb-3">
          <div class="vx-col sm:w-1/2 w-full mb-2">
            <label>Name</label>
            <vs-input :disabled="isReadOnly" autocomplete="off" onClick="this.select();" class="w-full" v-validate="'required|alpha_spaces'" name="Name" v-model="formData.name" />
            <span class="text-danger text-sm" v-show="errors.has('Name')">{{ errors.first('Name') }}</span>
          </div>
        </div>

        <vs-divider></vs-divider>
        
        <div class="vx-row">
          <vs-spacer></vs-spacer>
          <div class="vx-col">
            <vs-button v-if="!isReadOnly" color="success" class="mr-3 mb-2 vs-con-loading__container" @click.prevent="saveEditLanguage" ref="saveEditButton">Save</vs-button>
            <vs-button v-if="!isReadOnly" color="danger" class="mr-4 vs-con-loading__container cursor-pointer" v-show="formData.id" @click="deleteLanguage" ref="deleteButton">Delete</vs-button>
            <vs-button v-if="!isReadOnly" color="warning" type="border" class="mb-2" v-scroll-to="'#languageInfoCard'" @click="cancelAdd">Cancel</vs-button>
            <vs-button v-else color="warning" type="border" class="mb-2" v-scroll-to="'#languageInfoCard'" @click="cancelAdd">Close</vs-button>
          </div>
        </div>
      </vx-card>
    </div>
  </div>

</template>

<script>
export default {
  data() {
    return {
      loadingColor: "#fff",
      selected: [],
      isInfoHidden: true,
      isLanguageListHidden: false,
      languages: [],
      formData: {
        id: 0,
        name: "",
      },
      mode: "",
      isReadOnly: false
    };
  },
  methods: {
    initValues() {
      this.formData.id = 0;
      this.formData.name = "";
      this.mode = "";
      this.isReadOnly = false;
      this.errors.clear();
    },
    cancelAdd() {
      this.initValues();
      this.isInfoHidden = true;
      this.isLanguageListHidden = false;
    },
    addNewLanguage() {
      this.initValues();
      this.isLanguageListHidden = true;
      this.isInfoHidden = false;
      this.mode = "Add Language";
    },
    saveData() {
      this.loadLanguageData();
      this.$vs.loading.close(this.$refs.saveEditButton.$el);
    },
    loadLanguageData() {
      const self = this;
      self.showLoadingOnElement("languagesTable", 1, "corners");

      var onSuccess = function(response) {
        self.languages = response.data;
      };
      var onFinally = function() {
        self.$vs.loading.close(self.$refs.languagesTable.$el);
      };

      self.$ajaxGet(self, "language/listlanguages", onSuccess, onFinally);
    },
    handleSelectedLanguage(language) {
      this.mode = "Edit Language";
      this.formData.id = language.id;
      this.formData.name = language.name;
      this.isReadOnly = language.isReadOnly ? true : false;
      this.isLanguageListHidden = true;
      this.isInfoHidden = false;
    },
    saveEditLanguage() {
      var self = this;
      self.$validator.validateAll().then(result => {
        if (result) {
          self.showLoadingOnElement("saveEditButton", 0.45, "material");

          var onSuccess = response => {
            self.saveData();
            self.isInfoHidden = true;
            self.scrollToNavbar();
            self.isLanguageListHidden = false;
            self.$vs.notify({
              title: "Information",
              color: "success",
              text: "Language Saved",
              position: "top-right",
              iconPack: "feather",
              icon: "icon-save"
            });
          };
          var onFinally = function() {
            self.$vs.loading.close(self.$refs.saveEditButton.$el);
          };

          self.$ajaxPost(self, "language/addeditlanguage", self.formData, onSuccess, onFinally);
        } else {
          self.$vs.notify({
            title: "Attention",
            color: "warning",
            text: self.$validator.errors.items[0].msg,
            position: "top-right",
            iconPack: "feather",
            icon: "icon-info"
          });
        }
      });
    },
    deleteLanguage() {
      var self = this;
      self.showLoadingOnElement("deleteButton", 0.45, "material");

      var onSuccess = response => {
        self.saveData();
        self.initValues();
        self.isLanguageListHidden = false;
        self.isInfoHidden = true;
        self.$vs.notify({
          title:'Information',
          color: "success",
          text: "Language Deleted",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-trash'
        });
      };
      var onFinally = function () {
        self.$vs.loading.close(self.$refs.deleteButton.$el);
      };

      self.$ajaxDelete(self, "language/" + self.formData.id, onSuccess, onFinally);
    },
    showLoadingOnElement(element, scale, type){
      var self = this;
      self.$vs.loading({
        type: type,
        container: self.$refs[element].$el,
        scale: scale
      });
    },
    scrollToNavbar() {
      var scrollOptions = {
        easing: "ease-in",
        offset: -500,
        force: true,
        cancelable: true,
        x: false,
        y: true
      };
      var cancelScroll = this.$scrollTo(
        document.getElementById("navbarGlobal"),
        500,
        scrollOptions
      );
    }
  },
  mounted() {
    var self = this;
    self.loadLanguageData();
  }
};
</script>
